import actions from "./actions";

const {
    KNOWLEDGE_BASE_BEGIN,
    KNOWLEDGE_BASE_SUCCESS,
    KNOWLEDGE_BASE_ERR,
    KNOWLEDGE_BASE_ADD_BEGIN,
    KNOWLEDGE_BASE_ADD_SUCCESS,
    KNOWLEDGE_BASE_ADD_ERR,
    KNOWLEDGE_BASE_UPDATE_BEGIN,
    KNOWLEDGE_BASE_UPDATE_SUCCESS,
    KNOWLEDGE_BASE_UPDATE_ERR,
    KNOWLEDGE_BASE_DELETE_BEGIN,
    KNOWLEDGE_BASE_DELETE_SUCCESS,
    KNOWLEDGE_BASE_DELETE_ERR,
    KNOWLEDGE_BASE_GROUP_ADD_BEGIN,
    KNOWLEDGE_BASE_GROUP_ADD_SUCCESS,
    KNOWLEDGE_BASE_GROUP_ADD_ERR,
    KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN,
    KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS,
    KNOWLEDGE_BASE_GROUP_UPDATE_ERR,
    KNOWLEDGE_BASE_GROUP_DELETE_BEGIN,
    KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS,
    KNOWLEDGE_BASE_GROUP_DELETE_ERR,
} = actions;

const initState = {
    list: null,
    loading: false,
    adding: false,
    updating: false,
    deleting: false,
    groupAdding: false,
    groupUpdating: false,
    groupDeleting: false,
    error: null,
};

const KnowledgeBaseReducer = (state = initState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case KNOWLEDGE_BASE_BEGIN:
            return { ...state, loading: true, error: null };
        case KNOWLEDGE_BASE_SUCCESS:
            return { ...state, list: data, loading: false };
        case KNOWLEDGE_BASE_ERR:
            return { ...state, error: err, loading: false };

        case KNOWLEDGE_BASE_ADD_BEGIN:
            return { ...state, adding: true, error: null };
        case KNOWLEDGE_BASE_ADD_SUCCESS:
            return { ...state, adding: false };
        case KNOWLEDGE_BASE_ADD_ERR:
            return { ...state, adding: false, error: err };

        case KNOWLEDGE_BASE_UPDATE_BEGIN:
            return { ...state, updating: true, error: null };
        case KNOWLEDGE_BASE_UPDATE_SUCCESS:
            return { ...state, updating: false };
        case KNOWLEDGE_BASE_UPDATE_ERR:
            return { ...state, updating: false, error: err };

        case KNOWLEDGE_BASE_DELETE_BEGIN:
            return { ...state, deleting: true, error: null };
        case KNOWLEDGE_BASE_DELETE_SUCCESS:
            return { ...state, deleting: false };
        case KNOWLEDGE_BASE_DELETE_ERR:
            return { ...state, deleting: false, error: err };

        case KNOWLEDGE_BASE_GROUP_ADD_BEGIN:
            return { ...state, groupAdding: true, error: null };
        case KNOWLEDGE_BASE_GROUP_ADD_SUCCESS:
            return { ...state, groupAdding: false };
        case KNOWLEDGE_BASE_GROUP_ADD_ERR:
            return { ...state, groupAdding: false, error: err };

        case KNOWLEDGE_BASE_GROUP_UPDATE_BEGIN:
            return { ...state, groupUpdating: true, error: null };
        case KNOWLEDGE_BASE_GROUP_UPDATE_SUCCESS:
            return { ...state, groupUpdating: false };
        case KNOWLEDGE_BASE_GROUP_UPDATE_ERR:
            return { ...state, groupUpdating: false, error: err };

        case KNOWLEDGE_BASE_GROUP_DELETE_BEGIN:
            return { ...state, groupDeleting: true, error: null };
        case KNOWLEDGE_BASE_GROUP_DELETE_SUCCESS:
            return { ...state, groupDeleting: false };
        case KNOWLEDGE_BASE_GROUP_DELETE_ERR:
            return { ...state, groupDeleting: false, error: err };

        default:
            return state;
    }
};

export default KnowledgeBaseReducer;
